<template>
  <div class="tradeIn-change-status">
    <b-modal
      ref="tradeIn-change-status"
      hide-footer
      title="Đổi trạng thái phiếu định giá"
      no-close-on-backdrop
      size="lg"
    >
      <b-table
        class="table-common"
        hover
        bordered
        :items="tradeInItems"
        :fields="fields"
      >
        <template #cell(statusValidate)="data">
          <div v-if="!data.item.onLoading" class="d-table-row">
            <div class="d-table-cell align-middle" style="width: 10%">
              <i
                v-b-tooltip.hover
                :title="htmlGetStatusValidate(data.item, 'title')"
                :class="htmlGetStatusValidate(data.item, 'class')"
              ></i>
            </div>
            <div class="d-table-cell align-middle pb-1 pl-2" style="width: 90%">
              {{ data.item.statusValidateName }}
            </div>
          </div>
          <div v-else>
            <b-spinner
              small
              label="Small Spinner"
              variant="primary"
              class="mr-1"
            ></b-spinner>
            <span class="text-primary">Đang xử lí...</span>
          </div>
        </template>
        <template #cell(status)="data">
          <b-form-group class="mb-0 d-flex align-items-center">
            <div class="d-table-row">
              <div class="d-table-cell align-middle" style="width: 30%">
                <label class="font-weight-bold pt-1">
                  {{ data.item.statusName }}
                </label>
              </div>
              <div class="d-table-cell align-middle" style="width: 10%">
                <i
                  class="fa fa-arrow-right text-primary"
                  aria-hidden="true"
                ></i>
              </div>
              <div class="d-table-cell align-middle pb-1" style="width: 60%">
                <treeselect
                  :options="optionStatus"
                  :multiple="false"
                  placeholder="Chọn trạng thái"
                  noResultsText="Không có kết quả"
                  :match-keys="['label', 'custom']"
                  v-model="data.item.toStatus"
                  openDirection="bottom"
                  :clearable="false"
                  @select="onSelectStatus"
                >
                  <label
                    slot="option-label"
                    slot-scope="{ node, labelClassName }"
                    :class="labelClassName"
                  >
                    <span :title="node.label"> {{ node.label }}</span>
                  </label>
                </treeselect>
                <span
                  class="tree-select-custom"
                  v-if="isShowOption(data.item, 'fail-reason')"
                >
                  <treeselect
                    :options="optionFailReasons"
                    :multiple="false"
                    placeholder="Chọn lý do không thành công"
                    noResultsText="Không có kết quả"
                    :match-keys="['label', 'custom']"
                    v-model="data.item.failReason"
                    openDirection="bottom"
                    :clearable="false"
                  >
                    <label
                      slot="option-label"
                      slot-scope="{ node, labelClassName }"
                      :class="labelClassName"
                    >
                      <span :title="node.label"> {{ node.label }}</span>
                    </label>
                  </treeselect>
                </span>
              </div>
            </div>
          </b-form-group>
        </template>
      </b-table>
      <b-button
        style="fontweight: 600; width: 70px"
        variant="primary"
        size="sm"
        @click="onSubmit"
        >Lưu</b-button
      >
      <b-button
        style="margin-left: 10px; font-weight: 600; width: 70px"
        variant="secondary"
        size="sm"
        @click="hideModal"
        >Hủy</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import {
  TRADE_IN_STATUS,
} from '@/utils/enum';
import {
  TRADE_IN_FAIL_REASON,
  TRADE_IN_STATUS_OPTIONS,
} from '@/utils/constants';
import { makeToastFaile, makeToastSuccess, cloneDeep } from '@/utils/common';
import { checkPermission } from '@/utils/saveDataToLocal';
import { v4 as uuidv4 } from 'uuid';
import { featureFlagMixin } from '@/view/mixins';
const thStyleCommon = {
  textAlign: 'center',
  fontWeight: 600,
  color: '#181c32',
  width: '5%',
};
const STATUS_VALIDATE = {
  INVALID: 0,
  VALID: 1,
  REQUIRED: 2,
};

export default {
  mixins: [featureFlagMixin],
  data() {
    return {
      fields: [
        {
          key: 'id',
          label: 'ID',
          thStyle: {
            ...thStyleCommon,
            width: '20%',
          },
          formatter: (value) => {
            return `#${value}`;
          },
          tdClass: 'align-middle',
        },
        {
          key: 'status',
          label: 'Đổi trạng thái',
          thStyle: {
            ...thStyleCommon,
            width: '60%',
          },
          tdClass: 'align-middle',
        },
        {
          key: 'statusValidate',
          label: 'Kiểm tra',
          thStyle: {
            ...thStyleCommon,
            width: '20%',
          },
          tdClass: 'align-middle',
        },
      ],
      tradeInItems: [],
      optionStatus: [],
      onSubmiting: false,
      searchAccountant: '',
      filteredAccountantOptions: [],
      accountantOptions: [],
      selectedAccountantId: null,
      selectedAccountantCode: '',
      optionFailReasons: [],
      idempotenceKey: null,
    };
  },
  components: {
    Treeselect,
  },
  methods: {
    checkPermission,
    initOptions() {
      const acceptStatusChanges = [
        TRADE_IN_STATUS.UN_SUCCESS,
      ];
      const options = TRADE_IN_STATUS_OPTIONS.filter((tradeIn) =>
        acceptStatusChanges.includes(tradeIn.id),
      );
      this.optionStatus = options.reduce((result, element) => {
        result.push({
          id: element.id ? Number(element.id) : null,
          label: element.name,
          customLabel: element.name,
        });
        return result;
      }, []);

      this.optionFailReasons = TRADE_IN_FAIL_REASON
        .filter(element => element.id !== null)
        .map(element => ({
          id: Number(element.id),
          label: element.name,
          customLabel: element.name,
        }));
    },
    htmlGetStatusValidate(item, type) {
      let name = '';
      switch (item.statusValidate) {
        case STATUS_VALIDATE.VALID: {
          name =
            type === 'class' ? 'fas fa-check-circle text-success' : 'Hợp lệ';

          break;
        }
        case STATUS_VALIDATE.REQUIRED: {
          name =
            type === 'class'
              ? 'fas fa-check-circle text-warning'
              : 'Chưa chọn lí do';
          break;
        }
        default: {
          name =
            type === 'class'
              ? 'fas fa-times-circle text-danger'
              : 'Không hợp lệ';
          break;
        }
      }
      return name;
    },
    onSelectStatus(node) {
      const statusChanged = node.id;
      this.tradeInItems.map((item) => {
        const validateResult = this.validateChangeStatus(
          item.status,
          statusChanged,
        );
        item.statusValidate = validateResult.statusValidate;
        item.statusValidateName = validateResult.statusValidateName;
      });
    },
    showModal: function (data) {
      this.$refs['tradeIn-change-status'].show();
      this.tradeInItems = [cloneDeep(data)];
      this.initOptions();
    },
    hideModal() {
      this.$refs['tradeIn-change-status'].hide();
    },
    validateChangeStatus(currentStatus, selectedStatus) {
      if (currentStatus === selectedStatus) {
        return {
          statusValidate: STATUS_VALIDATE.INVALID,
          statusValidateName: 'Trùng trạng thái',
        };
      }
      return {
        statusValidate: STATUS_VALIDATE.VALID,
        statusValidateName: 'Hợp lệ!',
      };
    },
    async onSubmit() {
      if (this.onSubmiting) {
        return;
      }

      for (const tradeInItem of this.tradeInItems) {
        if (!tradeInItem.toStatus) {
          tradeInItem.statusValidate = STATUS_VALIDATE.REQUIRED;
          tradeInItem.statusValidateName = 'Vui lòng chọn trạng thái cần đổi!';
          makeToastFaile('Vui lòng chọn trạng thái cần đổi!');
          return;
        }
        if (tradeInItem.toStatus === TRADE_IN_STATUS.UN_SUCCESS && !tradeInItem.failReason) {
          makeToastFaile('Vui lòng chọn lý do không thành công!');
          return;
        }
      }

      if (!this.isValidDataSubmit()) {
        return makeToastFaile('Vui lòng chọn trạng thái hợp lệ!');
      }

      let hasError = false;

      for (const tradeInItem of this.tradeInItems) {
        const result = await this.onCallUpdateStatus(tradeInItem);
        if (result === false) {
          hasError = true;
        }
      }

      if (!hasError) {
        this.$emit('submit-data-tradeIn-success', true);
        this.hideModal();
      }

      this.onSubmiting = false;
    },
    async onCallUpdateStatus(data) {
      if (!this.idempotenceKey) {
        this.idempotenceKey = uuidv4();
      }

      const payload = {
        id: data.id,
        status: Number(data.toStatus),
        failReason: Number(data.failReason),
      };
      console.log("payload", payload);
      
      this.onSubmiting = true;

      try {
        const { data: responseData } = await ApiService.put(
          'tradeIn/status',
          payload,
          this.idempotenceKey
        );

        this.idempotenceKey = uuidv4();

        makeToastSuccess(responseData.message);
        return true;

      } catch (err) {
        if (!err.response) {
          makeToastFaile(err.$error);
        } else {
          const message = err.response.data.message;
          makeToastFaile(message);
        }
        return false;
      }
    },
    isValidDataSubmit() {
      const inValidItem = this.tradeInItems.find(
        (item) => item.statusValidate !== STATUS_VALIDATE.VALID,
      );
      return inValidItem ? false : true;
    },
    isShowOption(item, name) {
      if (item.statusValidate === STATUS_VALIDATE.INVALID) {
        return false;
      }
      if (name === 'fail-reason') {
        return item.toStatus === TRADE_IN_STATUS.UN_SUCCESS;
      }
    },
  },
};
</script>

<style scoped>
.table-common /deep/ .vue-treeselect__input-container {
  padding-top: 0px;
}
.table-common /deep/ .vue-treeselect__control {
  border-radius: none;
  border: none;
  height: 2.5rem;
}

.table-common /deep/ .vue-treeselect__input {
  font-size: 22px;
}
</style>
